import { RouterProvider } from '@tanstack/react-router';
import router from '../router';
import { useRole } from '../contexts/RoleContext';

/**
 * Wrapper component that waits for role to be loaded before rendering the router.
 * This prevents race conditions where router guards check role before it's fetched from API.
 */
export function RoleAwareRouter() {
  const { isLoading } = useRole();

  // Show loading state while role is being fetched
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-wppBlue border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]" />
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Once role is loaded, render the router
  return <RouterProvider router={router} />;
}
